import { Injectable } from '@angular/core';

interface TranslationObject {
  location: string;
  carRequested: string;
  requestedTime: string;
  riyadhPark: string;
  description: string;
  amount: string;
  valetFees: string;
  total: string;
  sar: string;
  carParkedAt: string;
  checkInTime: string;
  keySlotNo: string;
  requestMyCar: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANG_KEY = 'selectedLanguage';
  private readonly DEFAULT_LANG = 'eng';

  private english: TranslationObject = {
    location: 'Location',
    carRequested: 'Car has successfully Requested!',
    requestedTime: 'Requested Time',
    riyadhPark: 'Riyadh Park',
    description: 'Description',
    amount: 'Amount',
    valetFees: 'Valet Fees',
    total: 'Total',
    sar: 'SAR',
    carParkedAt: 'Your car is parked at',
    checkInTime: 'Check-In time',
    keySlotNo: 'Key Slot No.',
    requestMyCar: 'Request My Car'
  };

  private arabic: TranslationObject = {
    location: 'الموقع',
    carRequested: 'تم طلب السيارة بنجاح!',
    requestedTime: 'وقت طلب الاسترجاع',
    riyadhPark: 'الرياض بارك',
    description: 'الوصف',
    amount: 'المبلغ',
    valetFees: 'رسوم خدمة صف السيارة',
    total: 'المجموع',
    sar: 'ر.س',
    carParkedAt: 'سيارتك متوقفة في',
    checkInTime: 'وقت التسليم',
    keySlotNo: 'رقم المفتاح',
    requestMyCar: 'اطلب سيارتي'
  };

  constructor() { }

  setLanguage(language: string): void {
    localStorage.setItem(this.LANG_KEY, language);
  }

  getLanguage(): string {
    return localStorage.getItem(this.LANG_KEY) || this.DEFAULT_LANG;
  }

  getCurrentLanguageObject(): TranslationObject {
    return this.getLanguage() === 'arb' ? this.arabic : this.english;
  }

  // Add getter methods to access private properties
  getLangKey(): string {
    return this.LANG_KEY;
  }

  getDefaultLang(): string {
    return this.DEFAULT_LANG;
  }
}